import echarts from "echarts";
import elementResize from 'element-resize-detector' // 尺寸监听组件
// /**
//  *
//  * @param data 从服务器获取到的数据
//  */
// export function quShiChart(data) {
//     console.log('showquShiChart',data);
//     const xAxisData = [], y1Data = [], y2Data = [], y3Data = [];
//     data.forEach(item=>{
//         xAxisData.push(item['年月日']);
//         y1Data.push(item['数量']);
//         y2Data.push(item['环比增长']);
//         // y3Data.push(item['同比增长']);
//     })

//     const quShiChart = echarts.init(document.getElementById('quShiChart'));
//     const option = {
//         tooltip: {
//             trigger: 'axis',
//             axisPointer: {
//                 type: 'cross',
//                 crossStyle: {
//                     color: '#999'
//                 }
//             }
//         },
//         toolbox: {
//             feature: {
//                 dataView: {show: true, readOnly: false},
//                 magicType: {show: true, type: ['line', 'bar']},
//                 restore: {show: true},
//                 saveAsImage: {show: true}
//             }
//         },
//         legend: {
//             data: ['数量', '环比增长']
//         },
//         xAxis: [
//             {
//                 type: 'category',
//                 data: xAxisData,//['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
//                 axisPointer: {
//                     type: 'shadow'
//                 }
//             }
//         ],
//         yAxis: [
//             {
//                 type: 'value',
//                 name: '数量',
//                 // min: 0,
//                 // max: 250,
//                 // interval: 50,
//                 axisLabel: {
//                     formatter: '{value} 条'
//                 }
//             },
//             {
//                 type: 'value',
//                 name: '环比增长率',
//                 // min: 0,
//                 // max: 25,
//                 // interval: 5,
//                 axisLabel: {
//                     formatter: '{value} %'
//                 }
//             }
//         ],
//         series: [
//             {
//                 name: '数量',
//                 type: 'bar',
//                 data: y1Data//[2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3]
//             },
//             {
//                 name: '环比增长',
//                 type: 'line',
//                 yAxisIndex: 1,
//                 data: y2Data//[2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3]
//             },
//             // {
//             //     name: '同比增长',
//             //     type: 'line',
//             //     yAxisIndex: 1,
//             //     data: y3Data//[2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2]
//             // }
//         ]
//     };
//     quShiChart.setOption(option, true);
// }



export function showWeekChart(data) {
    // console.log('sssss',data)
    const chengBenLiRunChart = echarts.init(document.getElementById('weekChart'));
    const xAxis = data.map(item => item['周']), legendData = [], series = [];
    Object.keys(data[0] ?? []).filter(item => item !== '周').forEach(item=>{
        // console.log('item',item)
        legendData.push(item+ '单数');
        series.push({
            name: item+ '单数',
            type: 'bar',
            barMaxWidth: 80,
            stack: item,
            data: [],
            // itemStyle: {
            //     normal: {
            //         color: function(params) {
            //                 // build a color map as your need.
            //                 var colorList = [
            //                   '#00B3FC','#2ACD50','#FFBC10','#923CBD','#27727B',
            //                    '#FE8463','#9BCA63','#FAD860','#F3A43B','#60C0DD',
            //                    '#D7504B','#C6E579','#F4E001','#F0805A','#26C0C0'
            //                 ];
            //                 return colorList[params.dataIndex]
            //             },
            //     }
            // },
        });
        // legendData.push(item + '销售额');
        // series.push({
        //     name: item+'销售额',
        //     type: 'bar',
        //     barMaxWidth: 80,
        //     stack: item,
        //     data: []
        // });
    });
    // console.log('series',series)
    series.forEach(seriesItem=>{
        const {name, stack} = seriesItem;
        // console.log('seriesItem',seriesItem)
        data.forEach(item=>{
            if (item[stack]) {
                seriesItem.data.push(item[stack][name.slice(stack.length)]);
            }
        })
    })

    const option = {
        title: {
            text: '最近一周各类工单占比',
            subtext: '',
            left:100,
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        legend: {
            data: legendData,
            bottom:'bottom',
        },
        // grid: {
        //     left: '3%',
        //     right: '4%',
        //     bottom: '3%',
        //     containLabel: true
        // },
        xAxis: [
            {
                type: 'category',
                data: xAxis
            }
        ],
        yAxis: [
            {
                type: 'value',
                name: '单数',
            }
        ],
        series: [
            ...series
           
        ]
    };
    chengBenLiRunChart.setOption(option, true);
}

export function showMonthChart(data) {
    // console.log('sssss',data)
    const chengBenLiRunChart = echarts.init(document.getElementById('monthChart'));
    const xAxis = data.map(item => item['月']), legendData = [], series = [];
    Object.keys(data[0] ?? []).filter(item => item !== '月').forEach(item=>{
        // console.log('item',item)
        legendData.push(item+ '单数');
        series.push({
            name: item+ '单数',
            type: 'line',
            barMaxWidth: 80,
            stack: item,
            data: [],
            itemStyle: {
                normal: {
                    color: function(params) {
                            // build a color map as your need.
                            var colorList = [
                              '#00B3FC','#2ACD50','#FFBC10','#923CBD','#27727B',
                               '#FE8463','#9BCA63','#FAD860','#F3A43B','#60C0DD',
                               '#D7504B','#C6E579','#F4E001','#F0805A','#26C0C0'
                            ];
                            return colorList[params.dataIndex]
                        },
                }
            },
        });
        // legendData.push(item + '销售额');
        // series.push({
        //     name: item+'销售额',
        //     type: 'bar',
        //     barMaxWidth: 80,
        //     stack: item,
        //     data: []
        // });
    });
    // console.log('series',series)
    series.forEach(seriesItem=>{
        const {name, stack} = seriesItem;
        // console.log('seriesItem',seriesItem)
        data.forEach(item=>{
            if (item[stack]) {
                seriesItem.data.push(item[stack][name.slice(stack.length)]);
            }
        })
    })

    const option = {
        title: {
            text: '月度工单处理趋势图',
            subtext: '',
            left:100,
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        legend: {
            data: legendData,
            bottom:'bottom',
        },
        // grid: {
        //     left: '3%',
        //     right: '4%',
        //     bottom: '3%',
        //     containLabel: true
        // },
        xAxis: [
            {
                type: 'category',
                data: xAxis
            }
        ],
        yAxis: [
            {
                type: 'value',
                name: '单数',
            }
        ],
        series: [
            ...series
           
        ]
    };
    chengBenLiRunChart.setOption(option, true);
}

export function showDayChart(data) {
    console.log('sssss',data)
    const chengBenLiRunChart = echarts.init(document.getElementById('dayChart'));
    const xAxis = data.map(item => item['日']), legendData = [], series = [];
    Object.keys(data[0] ?? []).filter(item => item !== '日').forEach(item=>{
        // console.log('item',item)
        legendData.push(item+ '单数');
        series.push({
            name: item+ '单数',
            type: 'line',
            barMaxWidth: 80,
            stack: item,
            data: [],
            itemStyle: {
                normal: {
                    color: function(params) {
                            // build a color map as your need.
                            var colorList = [
                              '#00B3FC','#2ACD50','#FFBC10','#923CBD','#27727B',
                               '#FE8463','#9BCA63','#FAD860','#F3A43B','#60C0DD',
                               '#D7504B','#C6E579','#F4E001','#F0805A','#26C0C0'
                            ];
                            return colorList[params.dataIndex]
                        },
                }
            },
        });
    });
    // console.log('series',series)
    series.forEach(seriesItem=>{
        const {name, stack} = seriesItem;
        // console.log('seriesItem',seriesItem)
        data.forEach(item=>{
            if (item[stack]) {
                seriesItem.data.push(item[stack][name.slice(stack.length)]);
            }
        })
    })

    const option = {
        title: {
            text: '工单处理日趋势图',
            subtext: '',
            left:100,
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        legend: {
            data: legendData,
            bottom:'bottom',
        },
        // grid: {
        //     left: '3%',
        //     right: '4%',
        //     bottom: '3%',
        //     containLabel: true
        // },
        xAxis: [
            {
                type: 'category',
                data: xAxis
            }
        ],
        yAxis: [
            {
                type: 'value',
                name: '单数',
            }
        ],
        series: [
            ...series
           
        ]
    };
    chengBenLiRunChart.setOption(option, true);
}

export function showWeekChart_ZC(data){
    // console.log('sssss',Object.keys(data[0] ?? []))
    const myChart = echarts.init(document.getElementById('weekChart_ZC'));
    // this.charts = echarts.init(myChart) // 图标ID初始化
    //         // 初始化element-resize-detector组件
    //         var elementResize = elementResize({
    //           strategy: 'scroll', // <- 推荐监听滚动，提升性能
    //           callOnAdd: true // 添加侦听器时是否应调用,默认true
    //         })
    //         elementResize.listenTo(myChart, function(element) {
    //           echarts.init(myChart).resize() // 当元素尺寸发生改变是会触发此事件，刷新图表
    //         });
    // const xAxis = data.map(item => item['周']), legendData = [], series = [];
    const xAxis =[], legendData = [], series = [];
    console.log('xAxis',xAxis)
    Object.keys(data[0] ?? []).filter(item => item !== '周').forEach(item=>{
        console.log('item',item)
        legendData.push(item);
        series.push({
            name: item,
            type: 'line',
            // barMaxWidth: 80,
            stack: item,
            data: [],
        });
    });

    var data1=[];
    var data2=[];
    data.forEach(ele => {  
        xAxis.push('第'+ele.周+'周');   
        data1.push(ele.计划任务数);
        data2.push(ele.实际执行数);
    });
    var seri1={};
    seri1.name='计划任务数';
    seri1.type='line';
    // seri1.stack='Total';
    seri1.data=data1;
    var seri2={};
    seri2.name='实际执行数';
    seri2.type='line';
    // seri2.stack='Total';
    seri2.data=data2;
        
    var option = {
        title: {
          text: '逐周计划任务与实际执行趋势对比'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: legendData
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxis
        },
        yAxis: {
          type: 'value'
        },
        color:['#2F5597','#15BB19'],
        series: [
            seri1,
            seri2
        ]
      };
    //   console.log('mychart',myChart)
    myChart.setOption(option);
    window.addEventListener("resize", function () {
        myChart.resize();
    });
}



export function indexCate(obj,data){
    const myChart = echarts.init(document.getElementById(obj));
    const xAxis =[], legendData = [], series = [];
    console.log('xAxis',xAxis)
    Object.keys(data[0] ?? []).filter(item => item !== '周').forEach(item=>{
        console.log('item',item)
        legendData.push(item);
        series.push({
            name: item,
            type: 'line',
            // barMaxWidth: 80,
            stack: item,
            data: [],
        });
    });

    var optData=[];
    data.forEach(ele => {  
        var obj = {};
        obj.value = ele.cnt;
        obj.name = ele.cate;        
        optData.push(obj);
    });
        
    var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: 'bottom',
          left: 'center'
        },
        // color:['#E6A23C','#26A3FF','#13CE66','#FF3D3D'],
        color:['#2F5597','#3A68BC','#6A8ED0','#9CB4E0','#B6C8E8','#D0DBF0','#DCE5F4'],
        series: [
          {
            name: '分类分布情况',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '20',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: optData
          }
        ]
      };
    //   console.log('mychart',myChart)
    myChart.setOption(option);
}